import { csrfToken } from '../global/csrf'
import { shopAnalyticsAddToBasket } from './analytics'

/**
 *
 * @param productId
 * @param amount
 * @param data
 * @param setData
 * @returns {Promise<any|{success: boolean}>}
 */
export async function shopBasketAddItem(productId, amount, data, setData) {
  if (!productId) {
    return {
      success: false,
    }
  }

  productId = parseInt(productId)

  try {
    const response = await fetch('get/api/shopBasket/addItem', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'X-CSRF-TOKEN': csrfToken,
      },
      body: JSON.stringify({
        productId,
        amount: amount || 1,
        data: data || {},
        set_data: setData || {},
      }),
    })

    if (!response.ok) {
      throw new Error('Something went wrong')
    }

    const responseData = await response.json()

    if (responseData.success) {
      responseData.items.forEach((item) => {
        if (item.uID === responseData.addedUID) {
          shopAnalyticsAddToBasket({
            ...item,
            amount,
          })
        }
      })
    }

    return responseData
  } catch (error) {
    console.error(error)
  }

  return {
    success: false,
  }
}

/**
 *
 * @param products
 * @returns {Promise<any|{success: boolean}>}
 */
export async function shopBasketAddItems(products = []) {
  if (!products.length) {
    return {
      success: false,
    }
  }

  try {
    const response = await fetch('get/api/shopBasket/addItemMultiple', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'X-CSRF-TOKEN': csrfToken,
      },
      body: JSON.stringify({
        data: products,
      }),
    })

    if (!response.ok) {
      throw new Error('Something went wrong')
    }

    const responseData = await response.json()

    return responseData
  } catch (error) {
    console.error(error)
  }

  return {
    success: false,
  }
}
